import {Erro} from "./Erro";

export class ResultadoConsultaErros {
  ideDoc: number;
  erros: Erro[];
}
